import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Card, Image } from 'semantic-ui-react';

import _get from 'lodash/get';

import { getImageUrl } from 'components/modules/files/services/files';
import {
  BusinessFileMetadataPropType,
  BusinessFilePropType,
} from 'components/modules/files/types/files';

import { getDisplayableAssociation } from './ImageCard.utils';
import MediaFileEditModal from '../../../MediaFileEditModal';

import './ImageCard.scss';

const propTypes = {
  file: BusinessFilePropType.isRequired,
  fileMetadata: BusinessFileMetadataPropType.isRequired,
  onSave: PropTypes.func,
};

const defaultProps = {
  onSave: null,
};

export default function ImageCard({ file, fileMetadata, onSave }) {
  const [fileEditModalOpen, setFileEditModalOpen] = useState(false);

  const url = getImageUrl(file);

  function onFileEdit(e) {
    e.preventDefault();
    e.stopPropagation();
    setFileEditModalOpen(true);
  }

  const association = _get(fileMetadata, 'metadata.locationAssociationCategory');

  return (
    <>
      <Card key={url} className="image-card">
        <Image src={url} wrapped ui={false} />

        <Card.Header className="association">{getDisplayableAssociation(association)}</Card.Header>
        <Button className="edit-button" icon="pencil" onClick={onFileEdit} />
      </Card>

      {fileEditModalOpen && (
        <MediaFileEditModal
          open={fileEditModalOpen}
          onClose={() => setFileEditModalOpen(false)}
          file={file}
          fileMetadata={fileMetadata}
          onSave={onSave}
        />
      )}
    </>
  );
}

ImageCard.propTypes = propTypes;
ImageCard.defaultProps = defaultProps;
